import React from 'react'
import { Section, Container, H2, P } from '../../shared'

export const ApplicationProcess = () => (
  <Section>
    <H2>Application Process</H2>
    <P>
      If any of that gets you excited, we’d love for you to apply to Penn Labs!
      After the written application, we invite qualified candidates to our
      second round. This takes place in two parts:
    </P>
    <ol>
      <li>
        <b>Technical challenge</b> where you can show off your skills. You’ll be
        given a few days to complete a take-home challenge. We hold an office
        hours event and are always available via email for questions.
      </li>
      <li>
        <b>Casual chat</b> with a current member, because we want to get to know
        you in person! Community and culture are very important to us. This
        conversation also gives you the chance to learn more about what being in
        Penn Labs is really like.
      </li>
    </ol>
  </Section>
)
